import Vue from "vue";
import _ from "lodash";
import makePy from "./helper/makePy";
import store from "./store";
Vue.prototype.comboFilterMethod = function comboFilterMethod(val) {
    if (!this.allOptions || !this.allOptions.length) {
        this.allOptions = this.options;
    }
    this.filteredOptionsCount = this.optionsCount;
    var options = searchObj.search(this.allOptions || [], (val || "").toLowerCase());
    this.allOptions.forEach(function (item) {
        if (options.indexOf(item) === -1) {
            item.visible = false;
            item.select.filteredOptionsCount--;
        }
        else {
            item.visible = true;
        }
    });
};
var searchObj = {
    searchKey: function (list, key) {
        return _.filter(list, function (item) {
            return (item.label || "").toLowerCase().indexOf(key) > -1;
        });
    },
    searchKeyByPinyin: function (list, key, isIgnoreCase) {
        if (isIgnoreCase === void 0) {
            isIgnoreCase = true;
        }
        return _.filter(list, function (item) {
            var arrRslt = makePy((item.label || "").toLowerCase());
            var isOk = false;
            _.forEach(arrRslt, function (model) {
                if (model.toLowerCase().indexOf(key) > -1) {
                    isOk = true;
                }
            });
            return isOk;
        });
    },
    search: function (list, key) {
        var result = this.searchKey(list, key);
        if (!result || result.length === 0) {
            result = this.searchKeyByPinyin(list, key);
        }
        return result;
    }
};
Vue.prototype.titleFilter = function (text) {
    if (!text) {
        return '<span></span>';
    }
    return '<span class="long-text" title="' + text + '">' + text + '</span>';
};
var filters = {
    stateArrow: function (value) {
        if (typeof value == "undefined") {
            return '';
        }
        return value ? "<span style='color:#FE7437;'>↑</span>" : "<span style='color:#29CB97;'>↓</span>";
    },
    diffShow: function (value, showNegative) {
        if (!value)
            return "";
        if (showNegative) {
            return value > 0 ? "<span style='color:#FE7437;font-weight:bold;'>" + value + "</span>" : "<span style='color:#1090ff;font-weight:bold;'>" + value + "</span>";
        }
        else {
            return value > 0 ? "<span style='color:#FE7437;font-weight:bold;'>" + value + "</span>" : "";
        }
    },
    lessOrMoreDiffShow: function (value, prefix) {
        if (value == undefined || value == null) {
            return "";
        }
        if (prefix == '少发') {
            return "<span style='color:red;'>" + prefix + "</span>&nbsp" +
                "<span style='color:red;font-weight:bold;'>" + value + "</span>";
        }
        else if (prefix == '多发') {
            return "<span style='color:red;'>" + prefix + "</span>&nbsp" +
                "<span style='color:red;font-weight:bold;'>" + value + "</span>";
        }
        else {
            return "<span style='font-weight:bold;'>" + value + "</span>";
        }
    },
    dynamicTitle: function (value) {
        var typeDict = store.getters.typeDict["0_" + value] || {};
        var color = typeDict.color, name = typeDict.name;
        return "<span style='color:" + color + ";border-color: " + color + ";'>" + name + "</span>";
    },
    dynamicStatus: function (value, statusName) {
        var typeDict = store.getters.typeDict["0_" + value] || {};
        var color = typeDict.color;
        return "<span style='color:" + color + ";'>" + statusName + "</span>";
    },
    newTitle: function (message) {
        var typeDict = store.getters.typeDict[(message.type === 1 ? 1 : 0) + "_" + (message.type === 1 ? message.notice_sub_type : message.notice_params.type)] || {};
        var color = typeDict.color, name = typeDict.name, unread = message.status == 0 ? "inline-block" : "none";
        return "<span style='position:relative;display:inline-block;width:24px;height:24px;border-radius:50%;line-height:24px;font-size:14px;font-weight:500;color:#fff;background: " + color + ";'>" + name + "<span style='position:absolute;top:0;right:0;width:6px;height:6px;border-radius:50%;background:#FF1A42;display:" + unread + "'></span></span>";
    },
};
Vue.prototype.AWFilter = filters;
